import BaseApi from "@/services/api/BaseApi.ts";

export default class RegistrationV4Api extends BaseApi {
    protected version: string = 'v4';

    public register(data: object) {
        return this.axios.post('/register', data);
    }
}
